import { FunnelIcon, MessageSquareIcon } from 'lucide-react';
import { FC } from 'react';

import { DIALOGS_TABLE_NAME } from '@/entities/conversations';
import { useHasPermission } from '@/entities/profile';
import { usePinnedPresetRoutes } from '@/entities/settings';
import { SidebarNavItem } from '@/shared/ui';

/**
 * Динамическое подменю закреплённых пресетов списка диалогов под группой «Контроль».
 *
 * Пункт ведёт на адрес раздела своего пресета; активность считает `SidebarNavItem` по общему
 * правилу меню, сам пресет применяет адрес (`usePresetSectionSync`).
 */
export const DialogPresetsDynamicMenu: FC = () => {
  const pinnedRoutes = usePinnedPresetRoutes(DIALOGS_TABLE_NAME);
  const allowView = useHasPermission('VIEW_CONVERSATION');

  if (!allowView || pinnedRoutes.length === 0) {
    return null;
  }

  return (
    <>
      {pinnedRoutes.map(({ preset, path }) => (
        <SidebarNavItem
          key={preset.id}
          path={path}
          icon={
            <span className="relative flex size-4 shrink-0">
              <MessageSquareIcon size={16} strokeWidth={1.25} />
              {/* Отступ снизу компенсирует хвостик облачка: значок встаёт по центру его тела */}
              <span className="absolute inset-0 flex items-center justify-center pb-0.5">
                <FunnelIcon size={8} strokeWidth={2.5} />
              </span>
            </span>
          }
          label={preset.name}
          tooltip={preset.name}
        />
      ))}
    </>
  );
};
